import React, { useCallback, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, HStack, Text, VStack } from '@chakra-ui/react';
import ProviderButtons, { providerName } from './ProviderButtons';
import { authDestination } from '../client/authContinuation';

export default function AuthMethods() {
  const [methods, setMethods] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');
  const [reauthenticate, setReauthenticate] = useState(false);
  const load = useCallback(async () => {
    const response = await fetch('/api/auth/methods', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    if (response.ok) {
      const value = await response.json();
      if (Array.isArray(value.providers) && Array.isArray(value.available_providers)) setMethods(value);
    }
  }, []);
  useEffect(() => { load().catch(() => {}); }, [load]);
  const disconnect = async provider => {
    setBusy(provider); setError('');
    try {
      const response = await fetch(`/api/auth/identities/${provider}`, { method: 'DELETE',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      const value = await response.json();
      if (!response.ok) { setReauthenticate(response.status === 401); throw new Error(value.error); }
      await load();
    } catch (failure) { setError(failure.message || 'Could not disconnect this login method.'); }
    finally { setBusy(''); }
  };
  if (!methods) return null;
  return <Box width="100%" py={8}>
    <Text fontSize="lg" fontWeight="bold" mb={4}>Connected logins</Text>
    <VStack spacing={4} align="stretch" maxW="480px">
      {methods.providers.map(provider => <HStack key={provider} justify="space-between">
        <Text>{providerName(provider)} connected</Text>
        <Button size="sm" variant="outline" isLoading={busy === provider}
          isDisabled={!methods.has_password && !methods.providers.some(other => other !== provider && methods.available_providers.includes(other))}
          onClick={() => disconnect(provider)}>Disconnect {providerName(provider)}</Button>
      </HStack>)}
      {!methods.has_password && methods.providers.length > 0 && methods.providers.filter(provider=>methods.available_providers.includes(provider)).length < 2
        && <Text fontSize="sm" color="gray.700">Add a password or another login method before disconnecting your only sign-in option.</Text>}
      <ProviderButtons intent="link" returnTo="/account" connected={methods.providers} divider={false}
        onError={failure => setReauthenticate(failure.status === 401)} />
      {error && <Alert status="error" role="alert">{error}</Alert>}
      {reauthenticate && <Button as={RouterLink} to={authDestination('/login','/account')} variant="link" alignSelf="flex-start">Sign in again to continue</Button>}
    </VStack>
  </Box>;
}
